/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TAddformGeocodeModel,
  IAddformGeocodeRequest,
  IMappers,
  IAddformGeocodeResponse,
  IAddformGeocodeResponseError,
  TAddformGeocodeResponse,
} from './types';

const defaultConfig: TAddformGeocodeModel = {
  apiType: 'legacy',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'monolith-python',
  pathApi: '/addform/v2/geocode/',
  hostType: 'api',
  responseType: 'json',
} as TAddformGeocodeModel;

function createAddformGeocodeModel(parameters: IAddformGeocodeRequest): TAddformGeocodeModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IAddformGeocodeOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IAddformGeocodeRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchAddformGeocode<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IAddformGeocodeOptions<TResponse200, TResponse400>): Promise<TResponse200 | TResponse400 | TAddformGeocodeResponse> {
  const { response, statusCode } = await httpApi.fetch(createAddformGeocodeModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IAddformGeocodeResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IAddformGeocodeResponseError);
    }
  }

  return { response, statusCode } as TAddformGeocodeResponse;
}

export { defaultConfig, createAddformGeocodeModel, fetchAddformGeocode };
